(function () {
    'use strict';

    angular.module("imApp").factory("priceListBusCoService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 667,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 668,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
